import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { paymentTermUpdate } from '../../../redux/actions/paymentTerms';

const EditPaymentTermModal = ({ payload, showEditPaymentTermModal, setShowEditPaymentTermModal, paymentTerm, editPaymentTerm }) => {
  const [termName, setTermName] = useState(null);
  const [period, setPeriod] = useState(null);

  const paymentTermJson = () => {
    return {
      term_name: termName,
      shipping_terms: period
    }
  }

  const changeName = (event) => {
    let value = event.target.value;
    
    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
    
    setTermName(value);
  }

  const changePeriod = (event) => {
    let value = event.target.value;
    
    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
    
    setPeriod(value);
  }

  const update = () => {
    editPaymentTerm(payload, paymentTerm.id, paymentTermJson());
    setShowEditPaymentTermModal(false);
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  return(
    <div className="main-overlay">
      <div style={{ top: '750px' }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowEditPaymentTermModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            
            <h3>Update {paymentTerm.term_name}</h3>

            <div className="fieldset">

              <div className="field field--medium">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Payment Name</label>
                <input type="text" value={termName} onFocus={focus} onBlur={blur} onChange={(e) => changeName(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">{paymentTerm.term_name}</div>
              </div>

              <div className="field field--medium">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Payment Period (days)</label>
                <input type="number" value={period} onFocus={focus} onBlur={blur} onChange={(e) => changePeriod(e)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder">{paymentTerm.shipping_terms}</div>
              </div>

            </div>

            <br/>

            <button className="bottom-5 btn btn-primary btn-medium" onClick={() => update()}>Update Payment Term</button>
          </div>
        </div>
      </div>
    </div>
  )

}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  editPaymentTerm: (payload, paymentTermId, paymentTerm) => dispatch(paymentTermUpdate(payload, paymentTermId, paymentTerm)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPaymentTermModal);

